














import {Component, Prop, Vue} from 'vue-property-decorator';
import {ProductDto} from '@eurogast/hub-client-typescript';
import AvailabilityEnum = ProductDto.AvailabilityEnum;


@Component
export default class CartButtonMessage extends Vue {

  @Prop({required: true})
  public availability: AvailabilityEnum;

  @Prop({required: true})
  public showConvenienceMessage: boolean;

  private isPreOrderProduct(): boolean {
    return this.availability === AvailabilityEnum.PREORDER;
  }

  private isNotDeliverable(): boolean {
    return this.availability === AvailabilityEnum.NOTDELIVERABLE;
  }
}

